import { render, staticRenderFns } from "./ViewMemberFile.vue?vue&type=template&id=7018987d"
import script from "./ViewMemberFile.vue?vue&type=script&lang=js"
export * from "./ViewMemberFile.vue?vue&type=script&lang=js"
import style0 from "./ViewMemberFile.vue?vue&type=style&index=0&id=7018987d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports